import React from 'react';
import Page from './Page';
import { Container } from "../styles/Container";
import { Heading } from "../styles/Heading";
import { Preamble } from "../styles/Preamble";

const ErrorPage = () => (
  <Page title="Error" bgColor="#f2f2f2">
    <Container style={{ minHeight: '450px' }}>
      <Heading big center>Något gick fel!</Heading>
      <Preamble>
        Något gick fel när vi försökte ladda in den här sidan. Testa ladda om sidan på nytt.
      </Preamble>
    </Container>
  </Page>
);

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/pages/ErrorPage.js